/// <amd-module name="Search/Code/Utils" />
import * as Utils from "Search/Shared/Utils";
import * as Constants from "Search/Code/Constants";
import { IVssPageContext } from "VSS/Platform/Context";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { CodeResult, VersionControlType, SearchQuery } from "Search/LegacyWebApi/Contracts/Code";

export function isVCType(itemType: VersionControlType): boolean {
    return isGitType(itemType) || isTfvcType(itemType);
}

export function isGitType(itemType: VersionControlType): boolean {
    return itemType.toString().toLowerCase() === VersionControlType[VersionControlType.Git].toString() || itemType === VersionControlType.Git;
}

export function isTfvcType(itemType: VersionControlType): boolean {
    return itemType.toString().toLowerCase() === VersionControlType[VersionControlType.Tfvc].toString() || itemType === VersionControlType.Tfvc;
}

export function isCustomType(itemType: VersionControlType): boolean {
    return itemType.toString().toLowerCase() === VersionControlType[VersionControlType.Custom].toString() || itemType === VersionControlType.Custom;
}


export function getItemResultKey(item: CodeResult): string | undefined {
    if (!item) {
        return;
    }

    let identifier: string;
    if (isTfvcType(item.vcType)) {
        identifier = `${item.collection}/${item.project}/${item.repository}/${item.changeId}/${item.path}`;
    } else {
        identifier = `${item.collection}/${item.project}/${item.repository}/GB${item.branch}/${item.path}`;
    }

    return identifier;
}

export function areQueriesSame(left: SearchQuery, right: SearchQuery): boolean {
    if (left.searchText !== right.searchText) {
        return false;
    }

    return Utils.areFiltersEqual(left.searchFilters, right.searchFilters);
}

export function getInitialTake(pageContext: IVssPageContext): number {
    const infiniteScroll = isFeatureFlagEnabled(pageContext, Constants.FeatureFlagConstants.InfiniteScroll, false);
    return infiniteScroll ? Constants.CodeSearchInfiniteScrollTakeResults : Constants.CodeSearchTakeResults;
}